export default () =>
  fetch('/api/sessionSignOut', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
  });
